/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CalendarDate from 'src/components/Calendar/DateRadio';
import Layout from './Layout';
import { Tick } from '../images/index';
import { newAnalyticsEvent, newVirtualPageView } from '../utils/analytics';
import { getUserModeId } from '../utils/userMode';
import { getDate, getWeekDay } from '../utils/dates';
import ConfirmationTime from './ConfirmationTime';
import { Routes } from '../types/Routes';
import Button from './Button';

interface Props {
    value: any;
}

const Confirmation = ({ value }: Props) => {
    const navigate = useNavigate();

    const { skeduloJobDetails, paramUserMode } = value;

    useEffect(() => {
        if (!skeduloJobDetails) {
            navigate(Routes.AUTH);
            return;
        }
        newVirtualPageView('Job confirmation', '/vpv/jobconfirmation');
        newAnalyticsEvent({
            category: 'Job confirmation',
            action: 'Landed',
            label: skeduloJobDetails.jobs?.edges[0]?.node?.Name || 'Job not found',
            value: getUserModeId(paramUserMode),
        });
    });

    if (!skeduloJobDetails) {
        return null;
    }

    const { dayOneDate, dayOneTime, dayTwoDate, dayTwoTime, dayThreeDate, dayThreeTime } = value;

    const openSurvey = () => {
        newAnalyticsEvent({
            category: 'Job confirmation',
            action: 'Clicked on survey',
            label: skeduloJobDetails.jobs?.edges[0]?.node?.Name || 'Job not found',
            value: getUserModeId(paramUserMode),
        });
        window.open(
            'https://docs.google.com/forms/d/e/1FAIpQLSekUzlp8NCwkUxZIjo-w3nA-ehAOQq12PA0oyw31rymR7S_Gw/viewform?usp=sf_link',
            '_blank'
        );
    };

    let refNumber;
    try {
        refNumber = skeduloJobDetails.jobs?.edges[0]?.node?.Name;
    } catch (error) {
        refNumber = '';
    }

    const header = 'Request received';
    const refNumberLine = `Your reference number: ${refNumber}`;
    const urgentText =
        'Our team is reviewing your request and assigning an engineer. We’ll send you an email and text message as soon as your appointment is confirmed.';
    const normalText =
        'Our team is reviewing your request and will confirm your appointment in the next 48 hours by email. Please note, during the winter months we prioritise emergencies and our most vulnerable customers, so wait times can be a little longer than expected.';

    const surveyText = 'We’d love to get your feedback on how we can improve the booking tool';
    const surveyButtonText = 'Super quick survey';

    const datesArray = [new Date(dayOneDate), new Date(dayTwoDate), new Date(dayThreeDate)];

    const timesArray = [dayOneTime, dayTwoTime, dayThreeTime];

    const jobUrgency = value.jobUrgency || value.urgency;

    return (
        <Layout>
            <div className="container confirmation">
                <div className="confirmation-header">
                    <Tick />
                    <h2>{header}</h2>
                    {refNumber ? (
                        <p>
                            <strong>{refNumberLine}</strong>
                        </p>
                    ) : (
                        ''
                    )}
                    {['Urgent', 'Critical'].includes(jobUrgency) ? (
                        <p>{urgentText}</p>
                    ) : (
                        <p>{normalText}</p>
                    )}
                </div>
                <ul className="confirmation-list">
                    {datesArray.map((date, index) => {
                        const elKey = `${date}-${timesArray[index][0]}`;
                        return (
                            <li key={elKey} className="confirmation-list-el">
                                <h3 className="confirmation-list-el-date">{getDate(date)}</h3>
                                <CalendarDate
                                    dateWeek={getWeekDay(date)}
                                    dateNum={date.getDate()}
                                    isChecked
                                />
                                <div className="confirmation-list-el-time">
                                    <section>
                                        <ConfirmationTime time={timesArray[index]} />
                                    </section>
                                </div>
                            </li>
                        );
                    })}
                </ul>
                <div className="confirmation-survey">
                    <p>{surveyText}</p>
                    <Button onClick={openSurvey}>{surveyButtonText}</Button>
                </div>
            </div>
        </Layout>
    );
};

export default Confirmation;
